import { Nullable } from '@app/core/utilities/types';

export const safeJSONparse = <T>(value: string): Nullable<T> => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};
